module.exports = __webpack_public_path__ + "static/media/medicine.7644dc78.svg";